(function () {
  // Countdown to a fixed, real end date (set in the theme editor). Hidden once it passes.
  document.querySelectorAll('[data-countdown]').forEach(function (bar) {
    var raw = (bar.getAttribute('data-end') || '').trim().replace(' ', 'T');
    var end = new Date(raw);
    var out = bar.querySelector('[data-countdown-time]');
    if (isNaN(end)) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var ms = end - new Date();
      if (ms <= 0) { bar.hidden = true; clearInterval(timer); return; }
      bar.hidden = false;
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    var timer = setInterval(tick, 1000);
    tick();
  });

  // Cart drawer: every cart change asks Shopify to re-render the drawer section and swaps it in
  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
    var swap = function (sections) {
      if (!sections || !sections['cart-drawer']) return;
      var tmp = document.createElement('div'); tmp.innerHTML = sections['cart-drawer'];
      var panel = tmp.querySelector('[data-cart-panel]');
      if (panel) drawer.querySelector('[data-cart-panel]').innerHTML = panel.innerHTML;
      placeGhosts();
    };

    // Taking an item down to 0 keeps its row at quantity 0 / $0.00, so one tap on + brings it back
    var ghosts = [];
    var makeGhost = function (row) {
      var g = row.cloneNode(true);
      g.classList.add('citem--zero');
      g.removeAttribute('data-variant');
      g.querySelector('.qty span').textContent = '0';
      var btns = g.querySelectorAll('.qty button');
      btns[0].disabled = true; btns[0].removeAttribute('data-qty-set');
      btns[1].removeAttribute('data-qty-set'); btns[1].setAttribute('data-ghost-add', row.getAttribute('data-variant'));
      var rm = g.querySelector('.citem__remove'); rm.removeAttribute('data-qty-set'); rm.setAttribute('data-ghost-remove', '');
      g.querySelector('.citem__line').innerHTML = '<div><span class="citem__now">$0.00</span></div>';
      return g;
    };
    var placeGhosts = function () {
      var list = drawer.querySelector('.cdrawer__items');
      ghosts = ghosts.filter(function (g) { return !list.querySelector('[data-variant="' + g.variant + '"]'); });
      ghosts.forEach(function (g) {
        var ref = list.querySelectorAll('.citem')[g.index];
        list.insertBefore(g.node, ref || list.querySelector('[data-cart-empty]'));
      });
      var empty = list.querySelector('[data-cart-empty]');
      if (empty) empty.hidden = ghosts.length > 0;
    };
    var setCount = function (n) {
      var btn = document.querySelector('[data-cart-open]'); if (!btn) return;
      var badge = btn.querySelector('.cart-count');
      if (!badge && n) { badge = document.createElement('span'); badge.className = 'cart-count'; btn.appendChild(badge); }
      if (badge) { badge.textContent = n; badge.hidden = !n; }
    };
    // Add-ons (product type "Add-on": Order Protection, Priority Handling) are only sold with a bed.
    // Whenever the cart holds add-ons and nothing else, they are removed: after every cart change, on page load and on Checkout.
    var ADDON_TYPE = 'Add-on';
    var guardNote = function () {
      var list = drawer.querySelector('.cdrawer__items'); if (!list || list.querySelector('[data-guard-note]')) return;
      var p = document.createElement('p'); p.className = 'cdrawer__note'; p.setAttribute('data-guard-note', '');
      p.textContent = 'Order Protection and Priority Handling only ship together with a bed, so they were taken out of the cart.';
      list.insertBefore(p, list.firstChild);
    };
    var guard = function (cart) {
      var hasMain = cart.items.some(function (i) { return i.product_type !== ADDON_TYPE; });
      var addons = cart.items.filter(function (i) { return i.product_type === ADDON_TYPE; });
      if (hasMain || !addons.length) return Promise.resolve(false);
      var updates = {}; addons.forEach(function (i) { updates[i.variant_id] = 0; });
      return LLCart.request('cart/update.js', { updates: updates }, true).then(function () { guardNote(); return true; });
    };
    window.LLCart = {
      open: function () { drawer.classList.add('is-open'); document.documentElement.classList.add('no-scroll'); },
      close: function () { drawer.classList.remove('is-open'); document.documentElement.classList.remove('no-scroll'); },
      guard: function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(guard); },
      request: function (path, body, skipGuard) {
        body.sections = 'cart-drawer';
        return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function (data) {
            swap(data.sections);
            return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
              setCount(c.item_count);
              return skipGuard ? data : guard(c).then(function () { return data; });
            });
          });
      }
    };
    LLCart.guard().then(function (removed) {
      if (removed && document.body.classList.contains('template-cart')) window.location.reload();
    }).catch(function () {});
    document.addEventListener('click', function (e) {
      var co = e.target.closest('button[name="checkout"]');
      if (!co || co.hasAttribute('data-guard-ok')) return;
      e.preventDefault();
      co.disabled = true;
      LLCart.guard().then(function (removed) {
        co.disabled = false;
        if (removed) { if (document.body.classList.contains('template-cart')) window.location.reload(); else LLCart.open(); return; }
        co.setAttribute('data-guard-ok', ''); co.click(); co.removeAttribute('data-guard-ok');
      }).catch(function () { co.disabled = false; co.setAttribute('data-guard-ok', ''); co.click(); co.removeAttribute('data-guard-ok'); });
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); LLCart.open(); return; }
      if (e.target.closest('[data-cart-close]') && e.target.closest('[data-cart-drawer]')) {
        if (e.target.closest('a[href]') && !e.target.closest('.cdrawer__empty')) return;
        e.preventDefault(); LLCart.close(); return;
      }
      var add = e.target.closest('[data-ghost-add]');
      if (add && drawer.contains(add)) {
        var vid = add.getAttribute('data-ghost-add');
        add.disabled = true;
        ghosts = ghosts.filter(function (g) { return g.variant !== vid; });
        LLCart.request('cart/add.js', { items: [{ id: +vid, quantity: 1 }] });
        return;
      }
      if (e.target.closest('[data-ghost-remove]') && drawer.contains(e.target)) {
        var gr = e.target.closest('.citem');
        ghosts = ghosts.filter(function (g) { return g.node !== gr; });
        gr.remove(); placeGhosts();
        return;
      }
      var q = e.target.closest('[data-qty-set]');
      if (q && drawer.contains(q)) {
        var row = q.closest('.citem');
        if (q.getAttribute('data-qty-set') === '0' && !q.classList.contains('citem__remove') && row) {
          var rows = [].slice.call(drawer.querySelectorAll('.cdrawer__items .citem'));
          ghosts.push({ variant: row.getAttribute('data-variant'), index: rows.indexOf(row), node: makeGhost(row) });
        }
        q.disabled = true;
        LLCart.request('cart/change.js', { line: +q.getAttribute('data-line'), quantity: Math.max(0, +q.getAttribute('data-qty-set')) })
          .catch(function () { window.location.href = root + 'cart'; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') LLCart.close(); });
  }

  // Back-to-top button appears after scrolling a screen down
  var toTop = document.querySelector('[data-to-top]');
  if (toTop) {
    window.addEventListener('scroll', function () { toTop.hidden = window.scrollY < window.innerHeight; }, { passive: true });
    toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  // Menu drawer
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = document.querySelector('[data-drawer="' + btn.getAttribute('data-drawer-open') + '"]');
      if (d) d.hidden = false;
    });
  });
  document.querySelectorAll('[data-drawer]').forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-drawer-close]')) d.hidden = true;
    });
  });

  // Product: gallery thumbs, pack picker, sticky bar
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb');
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
      }, { passive: true });
    }

    var jsonEl = root.parentNode.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var input = root.querySelector('[data-variant-input]');
    var addBtn = root.querySelector('[data-add-button]');
    var form = root.querySelector('[data-product-form]');

    // Add-ons that only show on one pack, and gifts that unlock from a pack
    function syncExtras(index) {
      root.querySelectorAll('[data-addon]').forEach(function (a) {
        var on = +a.getAttribute('data-show-on');
        var show = !on || on === index;
        a.hidden = !show;
        if (!show) { a.querySelector('[data-addon-check]').checked = false; a.classList.remove('is-checked'); }
      });
      root.querySelectorAll('[data-gift]').forEach(function (g) {
        g.classList.toggle('is-locked', index < +g.getAttribute('data-unlock-from'));
      });
    }
    root.querySelectorAll('[data-addon-check]').forEach(function (c) {
      c.addEventListener('change', function () { c.closest('[data-addon]').classList.toggle('is-checked', c.checked); });
    });
    syncExtras(+root.getAttribute('data-selected-index') || 1);

    // Add the pack plus any ticked add-ons in one go, then slide the cart drawer open
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.LLCart) return;
        e.preventDefault();
        var items = [{ id: +input.value, quantity: 1 }];
        root.querySelectorAll('[data-addon]').forEach(function (a) {
          if (!a.hidden && a.querySelector('[data-addon-check]').checked) items.push({ id: +a.getAttribute('data-addon-id'), quantity: 1 });
        });
        if (addBtn) addBtn.classList.add('is-loading');
        LLCart.request('cart/add.js', { items: items }).then(function () {
          if (addBtn) addBtn.classList.remove('is-loading');
          LLCart.open();
        }).catch(function () { form.submit(); });
      });
    }

    root.querySelectorAll('[data-pack-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        root.querySelectorAll('.pack').forEach(function (p) { p.classList.remove('is-selected'); });
        radio.closest('.pack').classList.add('is-selected');
        input.value = radio.value;
        syncExtras(+radio.closest('[data-pack]').getAttribute('data-pack-index'));
        if (!product) return;
        var v = product.variants.find(function (x) { return String(x.id) === radio.value; });
        if (v && v.featured_media && track) {
          var idx = product.media.findIndex(function (m) { return m.id === v.featured_media.id; });
          if (idx > -1) track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
        }
        if (v && addBtn) addBtn.disabled = !v.available;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    var sticky = document.querySelector('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }).observe(addBtn);
      sticky.querySelector('[data-sticky-buy-btn]').addEventListener('click', function () {
        addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  });
})();
